let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b1qY8")).then(() => parcelRequire('lE6mu'));